import { Player } from '@/types';
import { apiClient } from '@/utils/api';
import { mockPlayerService } from '@/utils/mockAuth';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

export const fetchPlayers = createAsyncThunk<
  FetchPlayersResponse,
  { search?: string; page?: number; limit?: number }
>('players/fetch', async (params, { rejectWithValue }) => {
  try {
    const { search = '', page = 1, limit = 10 } = params;
    const skip = (page - 1) * limit;

    const res = await apiClient.get<FetchPlayersResponse>('/users', {
      params: { search, skip, take: limit },
    });

    return res.data;
  } catch (err) {
    return rejectWithValue(err);
  }
});

export const getPlayerById = createAsyncThunk(
  'players/getPlayerById',
  async (id: string, { rejectWithValue }) => {
    try {
      const res = await mockPlayerService.getPlayerById(id);
      return res.data;
    } catch (error) {
      return rejectWithValue('API not working');
    }
  }
);

export const updatePlayerStatus = createAsyncThunk(
  'players/updatePlayerStatus',
  async ({ id, status }: { id: string; status: 'Active' | 'Blocked' }, { rejectWithValue }) => {
    try {
      return { id, status };
    } catch (error) {
      return rejectWithValue('Failed to update status');
    }
  }
);

interface PlayerState {
  players: Player[];
  player: Player | null;
  total: number;
  page: number;
  limit: number;
  loading: boolean;
}

const initialState: PlayerState = {
  players: [],
  player: null,
  total: 0,
  page: 1,
  limit: 10,
  loading: false,
};

interface FetchPlayersResponse {
  count: number;
  skip: number;
  take: number;
  data: Player[];
}

export const playerSlice = createSlice({
  name: 'players',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPlayers.pending, (state) => {
        state.loading = true;
      })

      .addCase(fetchPlayers.fulfilled, (state, action) => {
        console.log('action.payload', action.payload);
        state.loading = false;
        state.players = action.payload.data;
        state.total = action.payload.count;
      })

      .addCase(fetchPlayers.rejected, (state) => {
        state.loading = false;
      })

      .addCase(getPlayerById.fulfilled, (state, action) => {
        state.player = action.payload;
      })

      .addCase(updatePlayerStatus.fulfilled, (state, action) => {
        const { id, status } = action.payload;

        state.players = state.players.map((p) => (p.id === id ? { ...p, status } : p));

        if (state.player?.id === id) {
          state.player.status = status;
        }
      });
  },
});

export default playerSlice.reducer;
